import { useMemo } from 'react'

import { type AppViewState } from '@/components/templates/AppView'
import { useTeams } from '@/model/contexts/useTeams.ts'
import { teamCarType } from '@/pages/dashboard/data/teamCar'

interface UseSelectedTeamOptions {
  selectedTeamId?: string
}

export function useSelectedTeam({ selectedTeamId }: UseSelectedTeamOptions): Pick<AppViewState, 'selectedTeam'> {
  const { teams } = useTeams()
  return useMemo(() => {
    const team = teams.find(({ _id }) => _id === selectedTeamId)
    return {
      selectedTeam: team && {
        id: team._id,
        carNumber: team.number,
        carType: teamCarType(team.vehicle),
        usingMobileApp: team.usingMobileApplication,
      },
    }
  }, [selectedTeamId, teams])
}
